import { Folder, File, X } from "lucide-react";

export type SelectedFolderOrFileProps =
  | {
      type: "File" | "Folder";
      name: string;
      parentPath: string;
      canRemove?: false;
      handleRemoveSelectedFolder?: never; // shouldn't be passed if canRemove is false
    }
  | {
      type: "File" | "Folder";
      name: string;
      parentPath: string;
      canRemove: true;
      handleRemoveSelectedFolder: () => void;
    };

export const SelectedFolderOrFile = ({
  type,
  name,
  parentPath,
  canRemove = true,
  handleRemoveSelectedFolder,
}: SelectedFolderOrFileProps) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between rounded-md border px-3 py-2 text-sm">
        <div className="flex items-center gap-x-2">
          {type === "Folder" ? (
            <Folder className="h-4 w-4 text-amber-500" />
          ) : (
            <File className="mr-2 h-4 w-4 shrink-0 text-blue-500" />
          )}
          <div className="min-w-0">
            <span className="block truncate font-medium">{name}</span>
            {parentPath && (
              <span className="text-muted-foreground block truncate text-xs">
                {parentPath}
              </span>
            )}
          </div>
        </div>

        {canRemove && (
          <button
            onClick={handleRemoveSelectedFolder}
            className="ml-2"
            aria-label={`Remove ${name}`}
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};
